module.exports = __webpack_public_path__ + "static/media/metrics.8a049ae3.svg";